<template>
  <div class="Developer">
    <div class=" dev-content">
      <div class="col ListItemAnimation">
        <img style="width: 185px;" src="@/assets/172-img/dev3.png" alt="">
        <p style="line-height: 22px;">
          ZACD Group Limited (“ZACD”) is an integrated asset manager listed in Hong Kong. <br>
          Headquartered in Singapore, ZACD specialises in wealth management with core competencies in 
          real estate acquisition and project management, investment management, property and facilities 
          management, as well as financial advisory services across Asia Pacific. <br>
          As of December 2019, ZACD has managed more than $550 million in total equity funds as asset 
          under management (AUM), with an asset portfolio size of approximately S$10 billion. <br>
          ZACD has jointly invested and managed over 37 multi-class real estate projects across Asia Pacific. 
          Some of these projects include Northstar @ AMK, Flo Residence, Woodlands Industrial Xchange, 
          Parc Centros, Le Quest, Frontier Industrial Park in Johor Bahru, The Sebel West Perth Aire 
          Apartments and a three-storey office building in Melbourne.
        </p>
      </div>
      <div class="col ListItemAnimation">
        <img style="width: 185px;" src="@/assets/172-img/dev2.png" alt="">
        <p style="line-height: 22px;">
          Founded in 1987, Welltech Construction Pte Ltd is one of the most established construction 
          companies in Singapore. <br>
          We have a paid-up capital of S$35 million and our portfolio ranges from Government Institutional to 
          Housing Projects. We have accomplished large varieties of distinguished projects over the past three 
          decades and is recognized and ranked as Grade A1 Builder for General Building Works and Grade 
          B1 for Civil Engineering Works by the Singapore’s Building & Construction Authority. We are ISO 
          9001:2015, ISO 14001:2015, ISO 45001:2018 certified, BCA Green and Gracious accredited and have 
          achieved and received awards for recognition and honoring of our quality and safety performance.
        </p>
      </div>
      <div class="col ListItemAnimation">
        <img style="width: 185px;" src="@/assets/172-img/dev1.png" alt="">
        <p style="line-height: 22px;">
          FRX Capital is an award-winning landed and boutique developer affiliated with the esteemed Tong 
          Eng Group and Hong How Group. With numerous years of combined expertise in development, 
          construction, design, and capital markets, FRX Capital is a trusted name in the real estate sector. 
          Managing a portfolio exceeding $500 million in projects globally, the company blends visionary 
          leadership with unparalleled industry knowledge. <br>
          Driven by the principle of inclusivity and collaboration, FRX Capital thrives on forming strategic 
          partnerships to unlock real estate opportunities and deliver enduring value. While the company’s 
          influence spans international markets, its unwavering commitment to excellence remains deeply 
          rooted in Singapore. <br>
          FRX Capital’s achievements are underscored by a host of prestigious accolades, including multiple 
          awards for boutique and landed development. These honors highlight its dedication to crafting 
          innovative, high-quality developments that resonate with investors and buyers alike.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less">

.Developer {
  .dev-content {
    display: flex;
    flex-direction: column;
    width: 65vw;
    height: auto;
    margin: auto;
    .col{
      margin: 20px 0;
    }
  }
}
</style>

